import type { QueryClient } from "@tanstack/react-query";
import { notFound } from "@tanstack/react-router";
import { fetchDormantList } from "./queries";
import type { DormantFilterSearch } from "./schemas";

export function hygieneSection(permissions: readonly string[], requested?: "dormant" | "campaigns"): "dormant" | "campaigns" | null {
  const dormant = permissions.includes("users.read");
  const campaigns = permissions.includes("access_governance.read");
  if (campaigns && (requested === "campaigns" || !dormant)) return "campaigns";
  return dormant ? "dormant" : null;
}

export function loadIdentityHygiene(queryClient: QueryClient, tenantID: string, search: DormantFilterSearch, permissions: readonly string[]) {
  const section = hygieneSection(permissions, search.section);
  if (section === null) throw notFound();
  if (section === "campaigns") return;
  const { section: _section, ...filter } = search;
  return queryClient.ensureQueryData({
    queryKey: ["identity-hygiene", "dormant", tenantID, filter],
    queryFn: () => fetchDormantList(tenantID, filter),
  });
}
